import type { CharlieTableProps } from '../charlie-table.types';

// using any here because the type of the column isn't known or relevant here
export const defaultLabels: Partial<CharlieTableProps<any>['labels']> = {
	sortLabel: (column) => {
		const { header } = column.column.columnDef;
		if (typeof header === 'function') {
			const headerText = header(column.getContext());
			return typeof headerText === 'string' ? headerText : column.id;
		}
		return typeof header === 'string' ? header : column.id;
	},
	selectAllRows: 'Select all rows',
	selectRow: 'Select row',
	expandRow: 'Expand row',
	loadMore: 'Load more',
	loadMoreLabel: 'Load more rows',
	sortGroup: 'Sort options',
	sortAscending: 'Sort ascending',
	sortDescending: 'Sort descending',
	clearSorting: 'Clear sorting',
	resizeColumn: (column) => `Resize column: ${column.id}`,
	moreActions: (column) => `More actions for ${column.id} column`,
	moveColumnGroup: 'Move column options',
	moveColumnLeft: 'Move column to left',
	moveColumnRight: 'Move column to right',
	moveColumnFirst: 'Move column to first in table',
	moveColumnLast: 'Move column to last in table',
	columnVisibilityGroup: 'Column visibility options',
	pinColumn: 'Pin column',
	unpinColumn: 'Unpin column',
	hideColumn: 'Hide column',
};
